(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tabbed-tables"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function TabbedTables(el) {
    this.el       = el;
    this.tabs     = Array.from(el.querySelectorAll('.tt-tab'));
    this.panels   = Array.from(el.querySelectorAll('.tt-panel'));
    this.unitBtns = Array.from(el.querySelectorAll('.tt-unit-btn'));
    this._bind();
  }

  TabbedTables.prototype._bind = function () {
    var self = this;

    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        self._switchTab(tab.dataset.tab);
      });
      tab.addEventListener('keydown', function (e) {
        self._tabKeydown(e, tab);
      });
    });

    this.unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self._switchUnit(btn.dataset.unit);
      });
    });
  };

  TabbedTables.prototype._switchTab = function (tabName) {
    this.tabs.forEach(function (tab) {
      var active = tab.dataset.tab === tabName;
      tab.classList.toggle('tt-tab--active', active);
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach(function (panel) {
      var active = panel.id.indexOf('panel-' + tabName + '-') !== -1;
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  };

  TabbedTables.prototype._switchUnit = function (unit) {
    this.unitBtns.forEach(function (btn) {
      var active = btn.dataset.unit === unit;
      btn.classList.toggle('tt-unit-btn--active', active);
      btn.setAttribute('aria-pressed', String(active));
    });

    this.panels.forEach(function (panel) {
      panel.dataset.unit = unit;
    });
  };

  /* Arrow-key navigation within the tablist */
  TabbedTables.prototype._tabKeydown = function (e, current) {
    var tabs = this.tabs;
    var idx  = tabs.indexOf(current);
    var next;

    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      e.preventDefault();
      next = (idx + 1) % tabs.length;
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      e.preventDefault();
      next = (idx - 1 + tabs.length) % tabs.length;
    } else if (e.key === 'Home') {
      e.preventDefault();
      next = 0;
    } else if (e.key === 'End') {
      e.preventDefault();
      next = tabs.length - 1;
    } else {
      return;
    }

    tabs[next].focus();
    tabs[next].click();
  };

  function initAll(root) {
    (root || document).querySelectorAll('.tt-section').forEach(function (el) {
      if (!el._tabbedTables) {
        el._tabbedTables = new TabbedTables(el);
      }
    });
  }

  initAll();

  /* Shopify theme editor: re-init on section load */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
